import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { AlertCircle } from 'lucide-react';
export function PainSection() {
  return <Section background="white" className="text-center" data-id="element-157">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="max-w-3xl mx-auto space-y-5 md:space-y-8" data-id="element-158">
        <div className="inline-flex items-center justify-center w-14 h-14 md:w-16 md:h-16 rounded-full bg-red-50 text-red-500 mb-2" data-id="element-159">
          <AlertCircle className="w-7 h-7 md:w-8 md:h-8" data-id="element-160" />
        </div>

        <h2 className="text-2xl md:text-4xl font-bold text-gray-900" data-id="element-161">
          El problema no es "tener diabetes"… <br data-id="element-162" />
          <span className="text-red-500" data-id="element-163">es no saber qué comer hoy</span>
        </h2>

        <p className="text-lg md:text-xl text-gray-600 leading-relaxed" data-id="element-164">
          Cuando la glucosa importa, cada comida se convierte en una decisión
          con presión:
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-left max-w-2xl mx-auto py-3 md:py-6" data-id="element-165">
          {['¿Esto me sube?', '¿Cuánto es demasiado?', '¿Y si lo hago mal?', '¿Qué cocino para toda la familia?'].map((question, i) => <div key={i} className="bg-gray-50 p-4 rounded-lg border-l-4 border-[#BC6C25] shadow-sm" data-id="element-166">
              <p className="font-medium text-gray-800 italic" data-id="element-167">"{question}"</p>
            </div>)}
        </div>

        <div className="bg-[#FEFAE0] p-4 md:p-6 rounded-xl border border-[#DDA15E]/30" data-id="element-168">
          <p className="text-lg text-gray-800" data-id="element-169">
            Y lo peor: hay demasiada información suelta, contradictoria o
            extrema.
            <br data-id="element-170" />
            <span className="font-bold text-[#2D6A4F] block mt-2" data-id="element-171">
              Esta guía existe para darte claridad + estructura + recetas en una
              sola dirección.
            </span>
          </p>
        </div>
      </motion.div>
    </Section>;
}